import React from "react";
import eventImage from "assets/images/common/others/exploreEvents.png";
import HostImage from "assets/images/common/others/attende1.png";
import { ReactComponent as ReviewGolden } from "assets/images/common/svgs/reviewGolden.svg";
import eventBadge from "assets/images/common/others/eventBadge.png";
import dummyImage from "assets/images/common/others/minorImage.png";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enum";

interface Props {
  eventData: any;
}

const EventDetail = ({ eventData }: Props) => {
  const navigate = useNavigate();

  const goToRSVPDetail = () => {
    if (eventData?.rsvp?.id) {
      navigate(`${siteRoutes.viewRSVP}?id=${eventData.rsvp.id}`);
    }
  };

  const goToHostDetail = () => {
    if (eventData?.host?.id) {
      navigate(`${siteRoutes.viewHost}?id=${eventData.host.id}`);
    }
  };

  return (
    <div className="w-full lg:w-[750px]">
      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Learning Activity
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.description || "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Core Concepts
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.coreConcept
              ?.map((concept: any) =>
                concept
                  .toLowerCase()
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char: any) => char.toUpperCase())
              )
              .join(", ") || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Parent Supervision
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.parentSupervision === true
              ? "Yes"
              : eventData?.event?.parentSupervision === false
                ? "No"
                : "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Special Instructions
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.specialInstructions || "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4 max-w-60">
          <span className="text-sm font-semibold text-captionText">
            Physical Consideration
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.physicalConsideration || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4 ">
          <span className="text-sm font-semibold text-captionText">
            Digital Badge
          </span>
          <span className="">
            <img
              className="w-[60px] h-[60px] "

              src={
                eventData?.event?.eventBadge
                  ? concatPathWithBackendUrl(
                    eventData?.event?.eventBadge?.image?.name
                  )
                  : ""
              }
              alt="eventBadge"
            />
          </span>
        </div>
        {eventData?.rsvp ? (
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">RSVP</span>
            <span
              className="flex gap-3 items-center cursor-pointer"
              onClick={goToRSVPDetail}
            >
              <img
                className="w-10 h-10 rounded-full"
                src={
                  eventData?.rsvp?.profilePicUrl
                    ? concatPathWithBackendUrl(
                      eventData?.rsvp?.profilePicUrl.fileDownloadUri
                    )
                    : editProfilePicUser
                }
                alt="RSVP"
              />
              <p className="text-base font-bold text-primaryText">
                {eventData?.rsvp?.firstName || "-"}{" "}
                {eventData?.rsvp?.lastName || ""}
              </p>
            </span>
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            <span className="text-sm font-semibold text-captionText">Host</span>
            <span
              className="flex gap-3 items-center cursor-pointer"
              onClick={goToHostDetail}
            >
              <img
                className="w-10 h-10 rounded-full"
                src={
                  eventData?.host?.profilePicUrl
                    ? concatPathWithBackendUrl(
                      eventData?.host?.profilePicUrl.fileDownloadUri
                    )
                    : editProfilePicUser
                }
                alt="Host"
              />
              <p className="text-base font-bold text-primaryText">
                {eventData?.host?.firstName || "-"}{" "}
                {eventData?.host?.lastName || ""}
              </p>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventDetail;
